import { httpAxios } from "../utils/httpAxios";

export const getAllBlogsService = async()=>{
    const result= await httpAxios.get('/admin/get/all/blogs').then((res)=>{
        return res.data
        }).catch((err)=>{
            return err.response.data;
        });  
        return result;
}
